import React from "react";
import { UsersRound } from "lucide-react";
import { PartnerGrowthItem } from "../../../../Redux/referral/types";

interface Props {
    data: PartnerGrowthItem[];
    loading: boolean;
    error: string | null;
}

const getStatusClass = (status: string) => {
    switch (status?.toLowerCase()) {
        case "success":
            return "success";
        case "rejected":
            return "rejected";
        case "pending":
            return "pending";
        default:
            return "other";
    }
};

const PartnerGrowthTable = ({ data, loading, error }: Props) => {
    return (
        <table className="partner-growth-table">
            <thead>
                <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Date</th>
                    <th scope="col">My Partner Growth ID</th>
                    <th scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
                {loading ? (
                    <tr>
                        <td colSpan={4} className="partner-growth-empty">
                            <strong>Loading...</strong>
                        </td>
                    </tr>
                ) : error ? (
                    <tr>
                        <td colSpan={4} className="partner-growth-empty">
                            <strong>{error}</strong>
                        </td>
                    </tr>
                ) : data.length === 0 ? (
                    <tr>
                        <td colSpan={4} className="partner-growth-empty">
                            <UsersRound size={27} strokeWidth={1.7} />
                            <strong>No referrals found</strong>
                            <span>Try a different search term or date range.</span>
                        </td>
                    </tr>
                ) : (
                    data.map((item, index) => (
                        <tr key={item.sellerId || index}>
                            <td>
                                <span className="partner-growth-table-primary">
                                    {item.sNo}
                                </span>
                            </td>
                            <td>
                                <span className="partner-growth-table-primary">
                                    {item.createdAt
                                        ? new Date(
                                              item.createdAt
                                          ).toLocaleDateString()
                                        : "-"}
                                </span>
                            </td>
                            <td>
                                <span className="partner-growth-id-badge">
                                    {item.sellerId || "N/A"}
                                </span>
                            </td>
                            <td>
                                <span
                                    className={`partner-growth-status ${getStatusClass(
                                        item.status
                                    )}`}
                                >
                                    {item.status || "N/A"}
                                </span>
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </table>
    );
};

export default PartnerGrowthTable;
